import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'lilac' | 'outline';
  size?: 'lg' | 'md';
  className?: string;
}
export function CtaButton({
  children,
  href,
  variant = 'lilac',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl font-extrabold uppercase tracking-wide transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--lilac)]/40 active:scale-[0.98]';
  const sizes = {
    lg: 'px-6 py-4 text-base sm:text-lg',
    md: 'px-5 py-3 text-sm sm:text-base'
  };
  const variants = {
    lilac: 'bg-[var(--lilac)] text-black hover:bg-[var(--lilac-light)] shadow-[0_0_30px_-8px_rgba(167,139,250,0.85)]',
    outline: 'border-2 border-[var(--violet-light)] bg-transparent text-[var(--cream)] hover:bg-[var(--violet)]/25'
  };
  const content = <>
      <span data-id="element-51" data-mp="35yz3ova6bcb0">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-52" data-mp="39yrfrhys00l4" />
    </>;
  if (href) {
    const isCheckout = href.includes('/cart/');
    const isTurbo = href.includes('48132893868084');
    return <a href={href} onClick={isCheckout ? () => trackInitiateCheckout(isTurbo ? 'Sistema Keto 365 + Keto Turbo' : 'Sistema Keto 365', isTurbo ? 27990 : 19990) : undefined} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-53" data-mp="3jy8lu0hxwghm">
        {content}
      </a>;
  }
  return <button type="button" className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-54" data-mp="bif1tboegmvt">
      {content}
    </button>;
}